module.exports = __webpack_public_path__ + "static/media/intro-photowall-29.30d71b02.jpg";